import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
//单头自定义字段
import HeadCustField from 'components/headCustField';
import BodydCustField from 'components/bodyCustField';
import { ActionContext } from 'actions/context';
import CustFieldService from 'services/custField';
import useDetail from 'hooks/useDetail';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CompanyService from 'services/company2';
import Util from 'lib/util.js';
import QtyRevise from 'components/qtyRevise.jsx';
import ReceiveService from 'services/receive.ts';
import Upload from 'components/upload.jsx';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';

/**
 * 入库单详情
 *
 */

const Config = {
  purchase: {
    title: '入库单详情',
    apiPath: '/storageOrder/detail',
    enumMainKey: 'B02_NPo_Status',
    receiveStatusKey: 'B02_Po_Receive_Status',
    companyNameKey: 'innerVendorName',
    idField: 'roXkNo',
    wfmCode: '1054',
    custFieldBillType: 13, //自定义字段单别
    arrEnumField: [
      {
        mainKey: 'B02_Is_Contain_Tax',
        subKey: 'isContainTax',
        value: 'isContainTaxName'
      },
      {
        mainKey: 'B02_Sto_Status',
        subKey: 'status',
        value: 'statusName'
      },
      {
        mainKey: 'B02_Order_Sync_Status',
        subKey: 'syncStatus',
        value: 'syncStatusName'
      }
    ],
    statusClass: ['gray', 'green', 'gray-blue', 'blue', 'orange'] //0.已冻结 1.有效 2.草稿 3.已确认 4.已撤回
  }
};

function StorageDetail(props) {
  const { state, dispatch } = useContext(ActionContext);

  let config = Config[props.type];
  config.dispatch = dispatch;
  const {
    companyCode,
    inited,
    error,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    detail,
    setShowLoading,
    setRedirect,
    setDetail,
    fieldSetting,
    self,
    uploadFile,
    fileConfig,
    setFileConfig,
    updateTs,
    workflow
  } = useDetail(props, config);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    setFileConfig({
      113: {
        xkNoField: 'stoXkNo',
        lineNoField: 'lineNo',
        canUpload: true,
        queueLimit: 50,
        maxFileSize: 50,
        totalMaxFileSize: 50,
        fileType: 'file'
      }
    });

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props, setFileConfig]);

  const [isShowStore, setIsShowStore] = useState(false);
  const [isGodown, setIsGodown] = useState(false);
  const [lineList, setLineList] = useState([]);
  const [currItem, setCurrItem] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  self.afterGetDetail = async function (data) {
    data.taxRate = data.taxRate * 100 + '%';
    // 入库时间编辑展示
    data.erpStorageDateShow =
      formatDate(data.erpStorageDate, 'YYYY-MM-DD') || '';
    data.lineList.forEach((item, i) => {
      item.priceShow = item.isContainTax === 1 ? item.taxPrice : item.price;
      Util.genExtendFields(item.poLine);
    });

    //获取企业参数-是否启用平台收货流程
    CompanyService.getCompanyParamsByCodes(
      [companyCode],
      [
        'Use_platform_recieve_process',
        'Use_platform_verify_process',
        'Use_recieve_order_down_erp'
      ],
      true
    ).then(res => {
      let companyParams = {};
      let companyParamsFilter = {};
      res.forEach(row => {
        companyParams[row.paramCode] =
          row.paramType === 1 ? row.paramValue : row.paramValue === '1';
        companyParamsFilter[row.paramCode] = res.filter(
          item => item.paramCode === row.paramCode
        )[0].paramFilter;
      });

      /*
       * 启用平台收货流程，且下传ERP是入库单，可入库
       */
      setIsGodown(
        companyParams['Use_platform_recieve_process'] &&
          companyParams['Use_recieve_order_down_erp'] === '2'
      );

      setIsShowStore(
        companyParams['Use_platform_recieve_process'] &&
          companyParamsFilter['Use_platform_recieve_process'] === '1' &&
          companyParams['Use_recieve_order_down_erp'] === '2' &&
          Util.isEmpty(data.lineList[0].storeCode)
      );
    });

    //获取物料是否能维护计价数量的权限
    if ([2, 4].includes(data.status)) {
      checkValuationQty(data.lineList);
    }

    setDetail(data);
    setLineList(data.lineList);
  };

  //保存
  function save() {
    if (!CustFieldService.validate(detail, [], fieldSetting, true, dispatch)) {
      return;
    }
    //单头提交数据
    let headData = CustFieldService.getHeadData(
      fieldSetting,
      detail,
      self.isPurchase
    );
    let postbody = {
      companyCode,
      stoXkNo: detail.stoXkNo,
      erpStorageDate: detail.erpStorageDate,
      lineList,
      ...headData,
      apiPath: '/storageOrder/save'
    };
    ModalService.showLoading(dispatch);
    Http.post('/api/cloudCenter', postbody).then(response => {
      ModalService.hideLoading(dispatch);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        setIsEdit(false);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 同步ERP
  function handleAgainSync() {
    let postbody = { stoXkNo: self.id, companyCode: companyCode };
    ReceiveService.syncStorageNote(
      postbody,
      data => {
        self.getDetail();
      },
      dispatch
    );
  }

  //撤回
  function recall() {
    let postbody = { stoXkNo: self.id, companyCode: companyCode };
    ReceiveService.recallStorageNote(
      postbody,
      data => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //入库单发布
  function publish() {
    let ok = function () {
      let postbody = {
        stoXkNo: detail.stoXkNo,
        companyCode,
        apiPath: '/storageOrder/convertConfirm'
      };
      ModalService.showLoading(dispatch);
      Http.post('/api/cloudCenter', postbody).then(response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          ModalService.showTip('发布成功', dispatch);
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    ModalService.showConfirm('确认发布入库单？', ok, dispatch);
  }

  //删除入库单
  function deleteSto() {
    let ok = function () {
      let postbody = {
        companyCode,
        stoXkNo: detail.stoXkNo,
        apiPath: '/storageOrder/delete'
      };
      ModalService.showLoading(dispatch);
      Http.post('/api/cloudCenter', postbody).then(response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          ModalService.showTip('删除成功', dispatch);
          setRedirect('/mp/purchase/receive/list');
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };

    ModalService.showConfirm('确认删除入库单？', ok, dispatch);
  }

  //删除单身行
  function deleteItems(item) {
    if (detail.lineList.length === 1) {
      ModalService.showError(
        '明细数据至少需保留一项，如想全部删除，请删除入库单。',
        dispatch
      );
      return;
    }

    let ok = () => {
      let postbody = {
        companyCode: companyCode,
        stoXkNo: self.id,
        storeLineNoList: [item.lineNo],
        apiPath: '/storageOrder/deleteOrderLine'
      };
      ModalService.showLoading(dispatch);
      Http.post('/api/cloudCenter', postbody).then(response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          ModalService.showTip('保存成功', dispatch);
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    ModalService.showConfirm('是否删除项次' + item.lineNo, ok, dispatch);
  }

  //获取物料是否能维护计价数量的权限
  function checkValuationQty(data) {
    data = data || [];
    let customerCode = companyCode;
    let productCodes = data.map(item => item.productCode);
    let postbody = {
      companyCode,
      customerCode,
      productCodes,
      apiPath: '/archives/customizeCategory/checkValuationQtyFlag'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        for (const key in response.data) {
          if (Object.prototype.hasOwnProperty.call(response.data, key)) {
            data
              .filter(item => item.productCode === key)
              .forEach(item => {
                item.isEditValuationQty =
                  response.data[key] === 1 ? true : false;
              });
          }
        }
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //日期改变
  function handleDateChange(e, name) {
    let obj = {};
    if (e.target.value) {
      obj[e.target.name] = e.target.value;
      obj[name] = e.target.valueAsNumber - 28800000;
    }
    setDetail(Object.assign({}, detail, obj));
  }

  //修改入库数量
  function handleEdit(item) {
    setCurrItem(item);
    dispatch({ type: 'showQtyRevise' });
  }

  //修改单身数据成功
  function handleModalChange(data) {
    if (data === 'success') {
      self.getDetail();
    }
  }

  function showUpload(item) {
    setCurrItem(item);
    uploadFile(113, item);
  }

  // 处理上传附件
  function handleUpload(data) {
    currItem.fileMd5s = data.map(item => item.fileMd5);
    save();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={'u-sign ' + config.statusClass[detail.status]}
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                {(detail.purchaseType !== 8 ||
                  (detail.purchaseType === 8 && detail.poSyncStatus !== 0)) && (
                  <li>
                    <span className="field-label">同步状态</span>
                    <div className="field-value">
                      <span
                        className={[
                          'u-sign' +
                            ' ' +
                            CommonFns.getStatusClass('sync', detail.syncStatus)
                        ]}
                      >
                        {detail.syncStatusName}
                      </span>
                    </div>
                  </li>
                )}
                {(detail.purchaseType !== 8 ||
                  (detail.purchaseType === 8 && detail.poSyncStatus !== 0)) &&
                  detail.syncMessage && (
                    <li>
                      <span className="field-label">同步消息</span>
                      <div>{detail.syncMessage}</div>
                    </li>
                  )}
                <li>
                  <span className="field-label">入库单号</span>
                  <div>{detail.stoErpNo}</div>
                </li>
                <li>
                  <span className="field-label">入库日期</span>
                  {!isEdit && (
                    <div className="field-value">
                      {formatDate(detail.erpStorageDate)}
                    </div>
                  )}
                  {isEdit && (
                    <div className="field-value">
                      <input
                        type="date"
                        name="erpStorageDateShow"
                        className="fieldDateClass"
                        value={detail.erpStorageDateShow || ''}
                        onChange={e => handleDateChange(e, 'erpStorageDate')}
                      />
                    </div>
                  )}
                </li>
                {detail.roErpNo && (
                  <li>
                    <span className="field-label">收货单号</span>
                    <div className="field-value">{detail.roErpNo}</div>
                  </li>
                )}
                {detail.erpReceiveDate && (
                  <li>
                    <span className="field-label">收货日期</span>
                    <div>{formatDate(detail.erpReceiveDate)}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">送货单号</span>
                  <div className="field-value">{detail.dnXkNo}</div>
                </li>
                <li>
                  <span className="field-label">交易条件</span>
                  <div className="field-value">{detail.conditionName}</div>
                </li>
                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">VMI发料单号</span>
                  <div className="field-value">{detail.vmiNo}</div>
                </li>
                <li>
                  <span className="field-label">交易税别</span>
                  <div className="field-value">
                    {detail.taxName}
                    {detail.taxName && ','}
                    {detail.isContainTaxName}
                    {detail.isContainTaxName && (
                      <span>, 税率{detail.taxRate}</span>
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">
                    {detail.payWayCode}-{detail.payWayName}
                  </div>
                </li>
                <li>
                  <span className="field-label">单别</span>
                  <div className="field-value">
                    {detail.formTypeCode}-{detail.formTypeName}
                  </div>
                </li>
                <li className={!isShowStore ? 'hide' : ''}>
                  <span className="field-label">入库仓库</span>
                  <div className="field-value">{detail.storeName}</div>
                </li>
                <li className={!isShowStore ? 'hide' : ''}>
                  <span className="field-label">入库库位</span>
                  <div className="field-value">{detail.locationName}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isEdit={isEdit}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>入库明细</label>
          </div>
          <div className="details-item-content">
            {lineList.map((item, index) => (
              <div
                className="content-line line-list-item"
                key={String(item.id) + index}
              >
                <div className="line-list-item-title">
                  <span>项次 {item.stoLineNoShow}</span>
                  {self.isPurchase && User.checkAuth('10030203') && (
                    <div className="more">
                      {[2, 4].includes(detail.status) && isGodown && (
                        <i
                          className="icon-edit"
                          onClick={() => {
                            handleEdit(item);
                          }}
                        ></i>
                      )}
                      {detail.status === 2 && (
                        <i
                          className="icon-delete"
                          onClick={() => {
                            deleteItems(item);
                          }}
                        ></i>
                      )}
                    </div>
                  )}
                </div>

                <ul className="field-list">
                  <li>
                    <span className="field-label">产品编码</span>
                    <div className="field-value">{item.productCode}</div>
                  </li>
                  <li>
                    <span className="field-label">产品名称</span>
                    <div className="field-value">{item.productName}</div>
                  </li>
                  <li>
                    <span className="field-label">产品规格</span>
                    <div className="field-value">{item.productScale}</div>
                  </li>
                  <li>
                    <span className="field-label">单价</span>
                    <div className="field-value">
                      {formatNumber(
                        item.priceShow,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">采购订单</span>
                    <div className="field-value">{item.poErpNo}</div>
                  </li>
                  <li>
                    <span className="field-label">入库数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.storageQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">计价数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.storageValuationQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>

                  <li>
                    <span className="field-label">入库单位</span>
                    <div className="field-value">{item.storageUnitName}</div>
                  </li>
                  <li>
                    <span className="field-label">计价单位</span>
                    <div className="field-value">{item.valuationUnitName}</div>
                  </li>
                  <li>
                    <span className="field-label">入库仓库</span>
                    <div className="field-value">{item.storeName}</div>
                  </li>
                  <li>
                    <span className="field-label">入库库位</span>
                    <div className="field-value">{item.locationName}</div>
                  </li>
                  <li>
                    <span className="field-label">入库批号</span>
                    <div className="field-value">{item.batchNo}</div>
                  </li>
                  <li>
                    <span className="field-label">收货数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.receiveQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">退货数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.returnQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </div>
                  </li>
                  {/* <li>
                      待转出货量：
                      {formatNumber(
                        item.srcReceiveQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}
                    </li> */}
                  <li>
                    <span className="field-label">采购单单身备注</span>
                    <div className="field-value">{item.poLineRemark}</div>
                  </li>
                  <li>
                    <span className="field-label">附件</span>
                    <div className="field-value">
                      {item.fileMd5s?.length && (
                        <span>{item.fileMd5s?.length}个附件</span>
                      )}
                      {isEdit && (
                        <a
                          href="#"
                          className="f-ml5"
                          onClick={() => {
                            showUpload(item);
                          }}
                        >
                          上传附件
                        </a>
                      )}
                    </div>
                  </li>
                  {item.poLine?.printExtendFields !== '' && (
                    <li>
                      <span className="field-label">采购说明</span>
                      <div className="field-value">
                        {item.poLine?.printExtendFields}
                      </div>
                    </li>
                  )}
                </ul>
                {/* 单身自定义字段 */}
                <BodydCustField
                  fieldSetting={fieldSetting}
                  line={item}
                  isPurchase={self.isPurchase}
                ></BodydCustField>
              </div>
            ))}
          </div>
        </div>
      </div>

      {self.isPurchase &&
      User.checkAuth('10030203') &&
      [2, 4].indexOf(detail.status) !== -1 ? (
        <div className="wrap m-flex-box fixed-bottom">
          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                save();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              保存
            </Button>
          )}
          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                setIsEdit(false);
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              取消
            </Button>
          )}
          {!isEdit && isGodown && (
            <Button
              type="default"
              onClick={() => {
                setIsEdit(true);
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              编辑
            </Button>
          )}
          {!isEdit && (
            <Button
              type="default"
              onClick={() => {
                deleteSto();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}

          {!isEdit && workflow?.data?.storageOrder_publish_1?.complete && (
            <Button
              type="default"
              className={isGodown ? 'm-flex-item u-btn u-btn_primary' : 'hide'}
              onClick={() => {
                publish();
              }}
            >
              发布
            </Button>
          )}
        </div>
      ) : (
        ''
      )}

      {/* 同步ERP */}
      <div className="wrap m-flex-box fixed-bottom">
        {self.isPurchase &&
          User.checkAuth('10030203') &&
          detail.status === 3 &&
          (detail.syncStatus === 3 || detail.purchaseType === 8) &&
          isGodown && (
            <Button
              type="default"
              onClick={() => {
                recall();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}

        {self.isPurchase &&
          User.checkAuth('10030203') &&
          detail.status === 3 &&
          detail.syncStatus === 3 &&
          isGodown && (
            <Button
              type="default"
              onClick={() => {
                handleAgainSync();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              同步ERP
            </Button>
          )}
      </div>

      {/* 编辑入库数量等 */}
      {self.isPurchase &&
        User.checkAuth('10030203') &&
        [2, 4].indexOf(detail.status) !== -1 &&
        isGodown &&
        !Util.isEmpty(currItem) && (
          <QtyRevise
            type="storageOrder"
            companyCode={companyCode}
            currItem={currItem}
            decimalPlace={decimalPlace}
            fieldSetting={fieldSetting}
            isPurchase={self.isPurchase}
            onChange={handleModalChange}
          />
        )}

      {/* 上传附件 */}
      {self.isPurchase &&
        User.checkAuth('10030203') &&
        [2, 4].indexOf(detail.status) !== -1 &&
        isGodown &&
        !Util.isEmpty(currItem) && (
          <Upload
            companyCode={companyCode}
            detail={currItem}
            isPurchase={self.isPurchase}
            onComplete={handleUpload}
          />
        )}

      <Modal></Modal>
    </div>
  );
}

StorageDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StorageDetail);
